import { useQuery } from "@tanstack/react-query";

import { getFootprintingFarmResourceConsumptionByPrimaryDataId, getFootprintingFarmResourceConsumptionByPrimaryDataIdAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_FARM_RESOURCE_CONSUMPTION } from "consts";

import { FootprintingFarmResourceConsumption } from "models";

export const useGetFootprintingFarmResourceConsumption = (primaryDataId: string) => {
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? getFootprintingFarmResourceConsumptionByPrimaryDataIdAdmin : getFootprintingFarmResourceConsumptionByPrimaryDataId;

  return useQuery<FootprintingFarmResourceConsumption>({
    queryKey: [FOOTPRINTING_FARM_RESOURCE_CONSUMPTION, primaryDataId],
    queryFn: () => queryFn(primaryDataId),
    enabled: !!primaryDataId,
    gcTime: 0,
  });
};
